import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import CreateAgent from './pages/CreateAgent';
import EditAgent from './pages/EditAgent';
import AgentSettings from './pages/AgentSettings';
import QuickButtons from './pages/QuickButtons';
import PublicChat from './pages/PublicChat';
import AuthCallback from './pages/AuthCallback';
import Pricing from './pages/Pricing';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionCancel from './pages/SubscriptionCancel';
import AdminServiceQueue from './pages/AdminServiceQueue';
import AdminPanel from './pages/AdminPanel';
import SystemSettings from './pages/SystemSettings';
import ProtectedRoute from './components/ProtectedRoute';

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (Emergent OAuth)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Public Landing Page */}
      <Route path="/" element={<LandingPage />} />
      
      {/* Auth Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      
      {/* Public Routes */}
      <Route path="/chat/:token" element={<PublicChat />} />
      <Route path="/pricing" element={<Pricing />} />
      
      {/* Protected Routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/subscription/success" element={
        <ProtectedRoute>
          <SubscriptionSuccess />
        </ProtectedRoute>
      } />
      <Route path="/subscription/cancel" element={
        <ProtectedRoute>
          <SubscriptionCancel />
        </ProtectedRoute>
      } />
      <Route path="/admin/service-queue" element={
        <ProtectedRoute>
          <AdminServiceQueue />
        </ProtectedRoute>
      } />
      <Route path="/admin/panel" element={
        <ProtectedRoute>
          <AdminPanel />
        </ProtectedRoute>
      } />
      <Route path="/admin/system-settings" element={
        <ProtectedRoute>
          <SystemSettings />
        </ProtectedRoute>
      } />
      
      <Route path="/agents/new" element={
        <ProtectedRoute>
          <CreateAgent />
        </ProtectedRoute>
      } />
      
      <Route path="/agents/:agentId/edit" element={
        <ProtectedRoute>
          <EditAgent />
        </ProtectedRoute>
      } />
      
      <Route path="/agents/:agentId/settings" element={
        <ProtectedRoute>
          <AgentSettings />
        </ProtectedRoute>
      } />
      
      <Route path="/agents/:agentId/buttons" element={
        <ProtectedRoute>
          <QuickButtons />
        </ProtectedRoute>
      } />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
